import { defineCustomElements } from "@blk/aladdin-web-components/dist/loader";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { ConnectedRouter } from "connected-react-router";
import React from "react";
import { isIE } from "react-device-detect";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { OidcProvider, loadUser } from "redux-oidc";
import { Provider as ReduxQueryProvider } from "redux-query-react";
import { start } from "single-spa";
import App from "./app";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { configuredStore, getQueries, history } from "./store";
import { setupReact18EventBridge } from "common/react18-event-bridge";
import { InsBrowserCompatibility } from "components/insBrowserCompatibility";
import { InsErrorBoundary } from "components/ux/insErrorBoundary";
import { reactPlugin } from "plugins/app-insight-init";
import { UxContextComponent } from "plugins/context";
import { userManager } from "plugins/oidc";
const isBrowserCompatible = !isIE;
export const appStore = configuredStore();
start();
defineCustomElements(window);
const container = document.getElementById("root") ?? document.body;
setupReact18EventBridge(container);
const root = createRoot(container);
const renderApp = async () => {
    if (isBrowserCompatible) {
        await loadUser(appStore, userManager);
        root.render(React.createElement(React.StrictMode, null,
            React.createElement(Provider, { store: appStore },
                React.createElement(AppInsightsContext.Provider, { value: reactPlugin },
                    React.createElement(InsErrorBoundary, null,
                        React.createElement(UxContextComponent.Provider, { value: {} },
                            React.createElement(OidcProvider, { userManager: userManager, store: appStore },
                                React.createElement(ReduxQueryProvider, { queriesSelector: getQueries },
                                    React.createElement(ConnectedRouter, { history: history },
                                        React.createElement(App, null))))))))));
    }
    else {
        root.render(React.createElement(React.StrictMode, null,
            React.createElement(InsBrowserCompatibility, { applicationUrl: window.location.href })));
    }
    /*
     * If you want your app to work offline and load faster, you can change
     * unregister() to register() below. Note this comes with some pitfalls.
     * Learn more about service workers: https://bit.ly/CRA-PWA
     */
    serviceWorkerRegistration.unregister();
};
renderApp();
